

export default function Section7() {
  return (

<section class="py-0 bg-[#f5f5f5]">
  <div class="container-1280 container mx-auto w-full px-[15px] md:w-[750px] lg:w-[970px] xl:w-[100%] items-center">

    <div>
      <h2 class="text-3xl font-bold mb-4 text-[#DA2128]">Our Services: Graphic Design That Works</h2>
      <p class="text-[16px] font-open text-[#373737] mb-6">
        When clients seek our graphic design services, they want visuals that align with their brand
        voice and goals in the market. That’s why we offer custom graphic design services tailored to
        your brand identity, target audience, and industry needs. We never rely on templates. Instead,
        we create unique and functional designs that reflect your brand’s values. Our team offers
        innovative and consistent graphic design services. We create visuals that are appealing and
        practical for both print and digital use.
      </p>

      <h2 class="text-3xl font-bold mb-4 text-[#DA2128]">Professional Graphic Design and Branding Services</h2>
      <p class="text-[16px] font-open text-[#373737]">
        We’re a trusted graphic designing company offering a full range of graphic
        design and branding services. Our goal is to help brands create a strong and lasting
        presence, whether you're launching a new product or rebranding an existing business. We rank
        among the best graphic design companies. Our strengths are attention to detail,
        speedy delivery, and a team-focused approach. Companies across the nation choose us for
        their graphic design needs. They rely on us for consistent, high-quality results every time.
      </p>
    </div>


  </div>
</section>


    
  );
}